<template>
  <ProtocolRulesFive></ProtocolRulesFive>
</template>

<script>
import ProtocolRulesFive from "@/components/ProtocolRulesFive";
export default {
  components: {
    ProtocolRulesFive,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/distributorApplication/distributorApplication.vue